import React, { Component } from "react";
import { Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { translationProposalsController } from "../../dataconnector/translationProposalsController";

class TranslationProposalsBadge extends Component {
  state = {
    pendingCount: 0,
  };

  componentDidMount() {
    this.unsubscribe = translationProposalsController.subscribeToPendingProposalsCount((count) => {
      this.setState({ pendingCount: count });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    const { pendingCount } = this.state;
    const { destination = "/TranslationProposalsView", t } = this.props;
    return (
      <Link
        to={destination}
        className="nav-link position-relative"
        style={{ padding: "0.5rem 1rem" }}
        title={t("proposals.view_title")}
      >
        <em className="fas fa-language" style={{ fontSize: "1.3rem", color: "white" }}></em>
        {pendingCount > 0 && (
          <Badge
            color={pendingCount > 5 ? "danger" : "warning"}
            pill
            style={{
              position: "absolute",
              top: "2px",
              right: "2px",
              fontSize: "0.7rem",
              minWidth: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #fff",
            }}
          >
            {pendingCount > 99 ? "99+" : pendingCount}
          </Badge>
        )}
      </Link>
    );
  }
}

export default withNamespaces("translations")(TranslationProposalsBadge);
